import { ClientEvent } from '@udemy/event-tracking';
export const BUYABLE_TYPES = {
  COURSE: 'course',
  SUBSCRIPTION: 'subscription'
};
export let ComponentVersion = /*#__PURE__*/function (ComponentVersion) {
  ComponentVersion["UDLITE"] = "udlite";
  ComponentVersion["UDHEAVY"] = "udheavy";
  return ComponentVersion;
}({});

/**
 * This map was created to derive a type in clients of the cart package, where
 * the union of the values of this object is the type needed for a variable.
 * Also, the enum version above is not available after build time, which
 * does not allow to use it to do checks.
 */
export const COMPONENT_VERSION = {
  UDLITE: 'udlite',
  UDHEAVY: 'udheavy'
};

/**
 * Fired when user clicks the Add To Cart button
 * In some cases (Frequently Bought Together), one click can add multiple items to the cart,
 * so buyables is an array.
 *
 * @deprecated Use BuyablesAddedToCart instead. This event will be removed in the future since it's a v1 event.
 */
export class AddToCartEvent extends ClientEvent {
  constructor({
    buyables,
    uiRegion
  }) {
    super('AddToCartEvent');
    this.buyables = void 0;
    this.uiRegion = void 0;
    this.buyables = buyables;
    this.uiRegion = uiRegion;
  }
}
export let BundleType = /*#__PURE__*/function (BundleType) {
  BundleType["CAREER_ACADEMY"] = "career-academy";
  return BundleType;
}({});

/**
 * This event is fired when a user adds one or more buyables to their shopping cart.
 *
 * Note that, this is a successor of AddToCartEvent, which is deprecated.
 */
export class BuyablesAddedToCart extends ClientEvent {
  constructor({
    buyables,
    uiRegion,
    bundleId,
    bundleType
  }) {
    super('BuyablesAddedToCart');
    this.buyables = void 0;
    this.uiRegion = void 0;
    this.bundleId = void 0;
    this.bundleType = void 0;
    this.buyables = buyables;
    this.uiRegion = uiRegion;
    this.bundleId = bundleId;
    this.bundleType = bundleType;
  }
}

/**
 * Fired when user clicks the Add To Cart button and sees an error message.
 * In some cases (Frequently Bought Together), one click can attempt to add multiple items to the
 * cart,so buyables is an array.
 */
export class CartErrorDisplayEvent extends ClientEvent {
  constructor({
    buyables,
    action,
    uiRegion
  }) {
    super('CartErrorDisplayEvent');
    this.buyables = void 0;
    this.action = void 0;
    this.uiRegion = void 0;
    this.buyables = buyables;
    this.action = action;
    this.uiRegion = uiRegion;
  }
}

/**
 * Fired when user clicks on the "Restrictions Apply" link on the
 * RefundNotice banner in the cart
 */
export class RefundNoticeTermsClickEvent extends ClientEvent {
  constructor() {
    super('RefundNoticeTermsClickEvent');
  }
}
export class CartMessageImpressionEvent extends ClientEvent {
  constructor(componentVersion, title, subTitle) {
    super('CartMessageImpressionEvent');
    this.componentVersion = componentVersion;
    this.title = title;
    this.subTitle = subTitle;
  }
}

/**
 * Fired when SliderMenu section is viewed by user
 */
export class CartSliderMenuImpressionEvent extends ClientEvent {
  constructor(componentVersion) {
    super('CartSliderMenuImpressionEvent');
    this.componentVersion = componentVersion;
  }
}

/**
 * Fired when Checkout Button in cart will be clicked
 */
export class CartCheckoutClickEvent extends ClientEvent {
  constructor(componentVersion) {
    super('CartCheckoutClickEvent');
    this.componentVersion = componentVersion;
  }
}

/**
 * Fired when a user sees a cart notification
 */
export class CartNotificationImpressionEvent extends ClientEvent {
  constructor(message, reason, componentVersion) {
    super('CartNotificationImpressionEvent');
    this.message = message;
    this.reason = reason;
    this.componentVersion = componentVersion;
  }
}

/**
 * Fired when a user sees a shopping list
 */
export class ShoppingListImpressionEvent extends ClientEvent {
  constructor(componentVersion, shoppingListType) {
    super('ShoppingListImpressionEvent');
    this.componentVersion = componentVersion;
    this.shoppingListType = shoppingListType;
  }
}
//# sourceMappingURL=events.js.map